module.exports = __webpack_public_path__ + "static/media/olake-product-7.d6c6ffb9.svg";